<template>
    <div class="bg-blue-300 rounded-full flex items-center justify-center font-bold text-white text-sm select-none border-2 border-blue-400" :style="{'width': `${this.width}px`, 'height': `${this.height}px`}">
        {{ this.letters }}
    </div>
</template>

<script>
export default {
    name: "WorkflowNameIcon",
    props: {
        /*
          letters: Инициалы workflow,
          width: Ширина в px,
          height: Высота в px,
          fontSize: Размер инициалов в rem
        */
        letters: String,
        width: Number,
        height: Number,
    },
}
</script>